module.exports = __webpack_public_path__ + "fonts/Prompt-Italic.80d507e9.ttf";